__turbopack_context__.v({
  "actionButton": "tenantDealvdrStyles-module-scss-module__0-b25G__actionButton",
  "lgContainer": "tenantDealvdrStyles-module-scss-module__0-b25G__lgContainer",
  "mdContainer": "tenantDealvdrStyles-module-scss-module__0-b25G__mdContainer",
  "mobileMenu": "tenantDealvdrStyles-module-scss-module__0-b25G__mobileMenu",
  "narrowContainer": "tenantDealvdrStyles-module-scss-module__0-b25G__narrowContainer",
  "pageContainer": "tenantDealvdrStyles-module-scss-module__0-b25G__pageContainer",
  "secondaryBtn": "tenantDealvdrStyles-module-scss-module__0-b25G__secondaryBtn",
  "sectionDescription": "tenantDealvdrStyles-module-scss-module__0-b25G__sectionDescription",
  "sectionTitle": "tenantDealvdrStyles-module-scss-module__0-b25G__sectionTitle",
});
